/** @jsx jsx */

import { ReactNode } from 'react';

import { jsx } from '@emotion/core';
import { Dropdown, Grid, Icon, Margin, Text } from '@zapier/design-system';

type DropdownItemType = {
  label: string;
  value: string;
  isDisabled?: boolean;
  iconAfter?: ReactNode;
};

type DropdownType = {
  title: string;
  items: Array<DropdownItemType>;
  value?: string;
  onSetValue: (value: DropdownItemType) => void;
};

type Props = {
  leftDropdown: DropdownType;
  rightDropdown: DropdownType;
};

const DoubleDropdowns = (props: Props) => {
  const { leftDropdown, rightDropdown } = props;

  const getLeftDropdownSelectedItem = () =>
    leftDropdown.items.find(i => leftDropdown.value === i.value);

  const getRightDropdownSelectedItem = () =>
    rightDropdown.items.find(i => rightDropdown.value === i.value);

  return (
    <Grid alignItems="center" columns="2fr 0.5fr 2fr" gap={10}>
      <Grid columns={1} gap={20}>
        <Text tag="h3" type="Title">
          {leftDropdown.title}
        </Text>
        <Dropdown
          items={leftDropdown.items}
          onChange={leftDropdown.onSetValue}
          placeholder={leftDropdown.value ? leftDropdown.value : 'Pick One'}
          renderIcon={(item: DropdownItemType) =>
            !!item && item.iconAfter && item.iconAfter
          }
          selectedItem={getLeftDropdownSelectedItem()}
        />
      </Grid>
      <Margin margin="35px auto 0px">
        <Icon name="arrowBigRight" size={24} />
      </Margin>
      <Grid columns={1} gap={20}>
        <Text tag="h3" type="Title">
          {rightDropdown.title}
        </Text>
        <Dropdown
          items={rightDropdown.items}
          onChange={rightDropdown.onSetValue}
          placeholder={rightDropdown.value ? rightDropdown.value : 'Pick One'}
          renderIcon={(item: DropdownItemType) =>
            !!item && item.iconAfter && item.iconAfter
          }
          selectedItem={getRightDropdownSelectedItem()}
        />
      </Grid>
    </Grid>
  );
};

export default DoubleDropdowns;
